const RADIO_BUTTON = [
  { variant: 'default', name: 'Default' },
  { variant: 'hover', name: 'Hover' },
  { variant: 'active', name: 'Active' },
  { variant: 'focus', name: 'Focus' },
  { variant: 'disabled', name: 'Disabled' }
]

export default RADIO_BUTTON
